// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wzxGU{display:block}.wzxGU svg{color:#101010}._8X6KH{padding:12px 20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "wzxGU",
	"tooltip": "_8X6KH"
};
module.exports = ___CSS_LOADER_EXPORT___;
